module.exports = __webpack_public_path__ + "static/mixed-fb-sb-99d64df23a3cc1e60a67aaa475706fdc.jpg";